import React__default, { forwardRef } from 'react';
import styled, { css } from 'styled-components';
import { Icon, __Icon } from '../icon/Icon.js';
import { Button } from './Button.js';

const ICON_SIZE_REM = {
    xsmall: 1,
    small: 1.25,
    medium: 1.75,
    large: 2.25,
    xlarge: 2.75
};
const getSizeRem = (size)=>{
    let sizeRem = ICON_SIZE_REM.medium;
    if (size !== undefined) {
        sizeRem = typeof size === "number" ? size : ICON_SIZE_REM[size];
    }
    return sizeRem;
};
const StyledButtonIcon = styled(Button)`
  min-width: 0;
  min-width: ${(props)=>(props.$size === "xsmall" ? 0.25 : 0.75) + (typeof props.$size === "number" ? props.$size : ICON_SIZE_REM[props.$size])}rem;
  padding: 0 0.4rem;
  font-size: 1rem;
  /* TODO: tidy up ButtonIcon size in relation to icons */
  ${(props)=>props.$size && css`
      height: ${getSizeRem(props.$size) + (props.$size === "xsmall" ? 0.25 : 0.75)}rem;
      width: ${getSizeRem(props.$size) + (props.$size === "xsmall" ? 0.25 : 0.75)}rem;
      font-size: ${getSizeRem(props.$size) + 0.25}rem;
      line-height: ${getSizeRem(props.$size) + 0.25}rem;

      &::before {
        line-height: inherit;
      }
    `}

  &:focus {
    outline: none;
  }

  /* display icons inline with a little jiggling of layouts */
  && > [${Icon.dataId}] {
    margin-right: 0;
    margin-left: 0;
    ${(props)=>props.$size && css`
        height: ${getSizeRem(props.$size)}rem;
        width: ${getSizeRem(props.$size)}rem;
        font-size: ${getSizeRem(props.$size)}rem;
        line-height: ${getSizeRem(props.$size)}rem;

        &::before {
          line-height: inherit;
        }
      `}
  }

  && > [${Icon.dataId}] > * {
    margin-left: 0;
  }
`;
/**
 * ButtonIcon
 *
 * Default action ButtonIcon used throughout app.
 *
 * TODO: remove font-size usage once no longer using font icon sheet
 *
 * @example
 * <ButtonIcon icon="icon-cancel" />
 * <ButtonIcon variant="context" icon="icon-cancel" />
 */ const ButtonIcon = forwardRef(({ variant ="default-inverse" , testId ="X" , icon ="close" , size ="medium" , children , ...props }, ref)=>{
    return React__default.createElement(StyledButtonIcon, {
        ...props,
        ref: ref,
        "data-hpy-web-buttonicon": true,
        testId: "ButtonIcon-" + testId,
        // Both sizes are needed as the Icon and Button sizes have different usecases / apply different styles
        // The $size variable represents resizing the button to fit the icon its wrapping.
        size: "medium",
        "$size": size,
        variant: variant
    }, React__default.createElement(__Icon, {
        icon: icon,
        size: size
    }), children);
});
ButtonIcon.dataId = "data-hpy-web-buttonicon";
ButtonIcon.displayName = "ButtonIcon";

export { ButtonIcon };
